module.exports = __webpack_public_path__ + "media/images/digivent/google_icon-3de4d638c3002cc14d8c8c64e7a7f51a.svg";